// Function to send analytics data
const sendAnalyticsdata = (objectValue) => {
  if (typeof adobeDataLayer !== "undefined") {
    if (typeof adobeDataLayer.push !== "undefined") {
      adobeDataLayer.push(objectValue);
    }
  }
};


export { sendAnalyticsdata };
